module.exports = __webpack_public_path__ + "img/ltkbump-3x.012d4d7.jpg";